// extracted by mini-css-extract-plugin
export default {"emptyResult":"EmptyResult_emptyResult__IAxd-"};